<main class="container-fluid">
  <div class="m-2">
    <div class="card mx-2">
      <div class="card-header d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center gap-3">
          <h4 class="mb-0">{{ pageTitle }}</h4>
          <!-- Mode badge -->
          <span *ngIf="isViewMode"
                class="badge"
                style="background:#1565c0;color:white;font-size:12px;padding:4px 10px;border-radius:12px;">
            <mat-icon style="font-size:14px;vertical-align:middle;width:14px;height:14px;">visibility</mat-icon>
            VIEW ONLY
          </span>
          <span *ngIf="isEditMode"
                class="badge"
                style="background:#e65100;color:white;font-size:12px;padding:4px 10px;border-radius:12px;">
            <mat-icon style="font-size:14px;vertical-align:middle;width:14px;height:14px;">edit</mat-icon>
            EDIT MODE
          </span>
        </div>
        <button mat-raised-button color="accent" (click)="navigateToList()"
                permission="Edu. Presentation"
                [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]">
          <mat-icon>list</mat-icon>
          View All Presentations
        </button>
      </div>
      <div class="card-body">
        <div class="row mx-3">
          <!-- Centre Dropdown — multi-select, empty = All Centres -->
          <app-searchable-select
            class="col-md-3 mt-2"
            [multiple]="true"
            [options]="loadedCentres"
            [selectedValue]="selectedCentreObjects"
            [valueKey]="'centreCode'"
            [displayWithFn]="displayCentre"
            [placeholder]="'Select Centre(s)'"
            [label]="'Select Centre(s)'"
            [hideSelectAllOption]="false"
            [isDisabled]="isViewMode"
            (selectionChange)="onCentreSelectionChange($event)">
          </app-searchable-select>

          <!-- Date Range Picker -->
          <mat-form-field appearance="outline" class="col-md-4 mt-2">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input [rangePicker]="picker" [disabled]="isViewMode">
              <input matStartDate [(ngModel)]="mStartDate" placeholder="Start date">
              <input matEndDate [(ngModel)]="mEndDate" placeholder="End date">
            </mat-date-range-input>
            <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>

          <!-- Components Visibility Dropdown -->
          <mat-form-field appearance="outline" class="col-md-3 mt-2">
            <mat-label>Show Sections</mat-label>
            <mat-select multiple [disabled]="isViewMode">
              <mat-option (click)="toggleAll(); $event.stopPropagation()">
                <mat-checkbox
                  [checked]="allSelected"
                  [indeterminate]="someSelected"
                  (change)="toggleAll()"
                  (click)="$event.stopPropagation()">
                  Select All
                </mat-checkbox>
              </mat-option>
              <mat-option *ngFor="let component of components" [value]="component" (click)="$event.stopPropagation()">
                <mat-checkbox
                  [checked]="component.visible"
                  (change)="toggleComponent(component.id)"
                  (click)="$event.stopPropagation()">
                  {{ component.label }}
                </mat-checkbox>
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Action Buttons -->
          <div class="col-md-2 mt-2">
            <!-- Search — hidden in view mode (data auto-loads) -->
            <button mat-mini-fab color="accent" (click)="Search()" matTooltip="Search"
                    *ngIf="!isViewMode">
              <mat-icon>search</mat-icon>
            </button>
            <span *ngIf="!isViewMode">&nbsp;</span>

            <!-- Clear — hidden in view mode -->
            <button mat-mini-fab color="warn" (click)="Clear()" matTooltip="Clear"
                    *ngIf="!isViewMode">
              <mat-icon>clear</mat-icon>
            </button>
            <span *ngIf="!isViewMode">&nbsp;</span>

            <!-- Save — only in Add/Edit mode -->
            <button mat-mini-fab color="primary" (click)="Save()" matTooltip="Save Presentation"
                    *ngIf="!isViewMode"
                    [disabled]="!searchPressed">
              <mat-icon>save</mat-icon>
            </button>
            <span *ngIf="!isViewMode">&nbsp;</span>

            <!-- Switch to Edit — only in View mode -->
            <button mat-mini-fab color="accent" (click)="switchToEditMode()"
                    matTooltip="Switch to Edit Mode"
                    *ngIf="isViewMode"
                    permission="Edu. Presentation"
                    [permissionTypes]="[PermissionType.ALL, PermissionType.EDIT]">
              <mat-icon>edit</mat-icon>
            </button>
            <span *ngIf="isViewMode">&nbsp;</span>

            <!-- Gallery — always available when data is loaded -->
            <button mat-mini-fab
                    style="background-color: #673ab7; color: white;"
                    (click)="openPhotoGallery()"
                    matTooltip="View Photo Gallery"
                    [disabled]="!searchPressed">
              <mat-icon>photo_library</mat-icon>
            </button>
          </div>


        </div>

        <!-- Content Area -->
        <div class="row mx-3 mt-4">
          <div class="col-12">
            <p *ngIf="!searchPressed" class="text-muted text-center">
              Please select a centre and date range, then click search to view the presentation.
            </p>

            <!-- Dynamic Components Rendering -->
            <div *ngIf="searchPressed">

              <!-- Statistics Overview Component -->
              <div *ngIf="isComponentVisible('teachers-structure')" class="component-section">
                <div class="section-header">
                  <mat-icon>analytics</mat-icon>
                  <h5>Teaching Team Structure & Distribution</h5>
                </div>
                <div class="section-content">
                  <!-- Teacher / Staff table — mirrors mis-education logic -->
                  <div class="table-responsive">
                  <table mat-table [dataSource]="dataSource" class="mat-elevation-z4 w-100">

                    <!-- Sr No -->
                    <ng-container matColumnDef="no">
                      <th mat-header-cell *matHeaderCellDef>Sr.</th>
                      <td mat-cell *matCellDef="let row; let i=index">{{ i+1 }}</td>
                      <td mat-footer-cell *matFooterCellDef><b>Total</b></td>
                    </ng-container>

                    <!-- Photo -->
                    <ng-container matColumnDef="photo">
                      <th mat-header-cell *matHeaderCellDef>Photo</th>
                      <td mat-cell *matCellDef="let row">
                        <img [src]="getPhoto(row.profileImages)"
                             (error)="onImageError($event)"
                             [alt]="row.userName"
                             style="width:40px;height:40px;border-radius:50%;border:1px solid #ccc;" />
                      </td>
                      <td mat-footer-cell *matFooterCellDef></td>
                    </ng-container>

                    <!-- Name -->
                    <ng-container matColumnDef="userName">
                      <th mat-header-cell *matHeaderCellDef>Teacher Name</th>
                      <td mat-cell *matCellDef="let row"><b>{{ row.userName }}</b></td>
                      <td mat-footer-cell *matFooterCellDef></td>
                    </ng-container>

                    <!-- Centre -->
                    <ng-container matColumnDef="centre">
                      <th mat-header-cell *matHeaderCellDef>Alloted Centres</th>
                      <td mat-cell *matCellDef="let row">
                        <ng-container *ngIf="row.centre?.length <= 1">
                          {{ row.centre.join(', ') }}
                        </ng-container>
                        <ng-container *ngIf="row.centre?.length > 1">
                          <span *ngIf="!row.expanded">
                            {{ row.centre.slice(0, 1).join(', ') }}
                            <a style="color:#3f51b5;cursor:pointer;" (click)="toggleCentre(row)">+ Read more</a>
                          </span>
                          <span *ngIf="row.expanded">
                            {{ row.centre.join(', ') }}
                            <a style="color:#3f51b5;cursor:pointer;" (click)="toggleCentre(row)">Read less</a>
                          </span>
                        </ng-container>
                      </td>
                      <td mat-footer-cell *matFooterCellDef></td>
                    </ng-container>

                    <!-- Individual Sessions -->
                    <ng-container matColumnDef="individualSessionCount">
                      <th mat-header-cell *matHeaderCellDef>Individual</th>
                      <td mat-cell *matCellDef="let row">{{ row.individualSessionCount }}</td>
                      <td mat-footer-cell *matFooterCellDef><b>{{ totalIndividual }}</b></td>
                    </ng-container>

                    <!-- Group Sessions -->
                    <ng-container matColumnDef="groupSessionCount">
                      <th mat-header-cell *matHeaderCellDef>Group</th>
                      <td mat-cell *matCellDef="let row">{{ row.groupSessionCount }}</td>
                      <td mat-footer-cell *matFooterCellDef><b>{{ totalGroup }}</b></td>
                    </ng-container>

                    <!-- Follow-Up -->
                    <ng-container matColumnDef="followUpCount">
                      <th mat-header-cell *matHeaderCellDef>Follow-Up</th>
                      <td mat-cell *matCellDef="let row">{{ row.followUpCount }}</td>
                      <td mat-footer-cell *matFooterCellDef><b>{{ totalFollowUp }}</b></td>
                    </ng-container>

                    <!-- Total -->
                    <ng-container matColumnDef="totalSessionCount">
                      <th mat-header-cell *matHeaderCellDef>Total</th>
                      <td mat-cell *matCellDef="let row">
<!--                    Total should only be row.individualSessionCount + row.groupSessionCount dont add followup counts here    -->
                        <b>{{ row.individualSessionCount + row.groupSessionCount  }}</b>
                      </td>
                      <td mat-footer-cell *matFooterCellDef>
                        <b style="color:#e53935;">{{ totalIndividual + totalGroup }}</b>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="teacherColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: teacherColumns;"></tr>
                    <tr mat-footer-row *matFooterRowDef="teacherColumns; sticky: true" class="footer-row"></tr>
                  </table>
                  </div>
                  <br>
                </div>
              </div>

              <!-- Education Session Counts New Component -->
              <div *ngIf="isComponentVisible('education-session-counts-new')" class="component-section">
                <div class="section-header">
                  <mat-icon>groups</mat-icon>
                  <h5>Education Sessions Report (Children Above 14 Years)</h5>
                </div>
                <div class="section-content">
                  <app-education-session-counts-new
                    [hideFilters]="true"
                    [externalStartDate]="mStartDate"
                    [externalEndDate]="mEndDate"
                    [externalCentre]="selectedCentres"
                    [triggerSearch]="searchTrigger">
                  </app-education-session-counts-new>
                </div>
              </div>

              <!-- Learning New Concepts Component -->
              <div *ngIf="isComponentVisible('learning-concepts')" class="component-section">
                <div class="section-header">
                  <mat-icon>psychology</mat-icon>
                  <h5>Learning New Concepts</h5>
                </div>
                <div class="section-content">

                  <!-- ── Concept multi-select ── -->
                  <div class="row mb-3">
                    <app-searchable-select
                      class="col-md-8 col-12"
                      [options]="learningConceptOptions"
                      [displayWithFn]="displayConcept"
                      [placeholder]="'Select Learning Concepts'"
                      [label]="'Select Learning Concepts'"
                      [selectedValue]="selectedLearningConcepts"
                      [multiple]="true"
                      [hideSelectAllOption]="false"
                      [isShowPlusIcon]="true"
                      [addTooltipPlusIcon]="'Add / Edit / Delete learning concepts'"
                      (addButtonClicked)="openManageLearningConcepts()"
                      (selectionChange)="selectedLearningConcepts = $event">
                    </app-searchable-select>
                  </div>

                  <!-- ── Selected concepts chip list ── -->
                  <div class="row mb-3" *ngIf="selectedLearningConcepts.length > 0">
                    <div class="col-12">
                      <p class="lc-chips-label">
                        <mat-icon>check_circle</mat-icon>&nbsp;Concepts covered this period:
                      </p>
                      <mat-chip-list class="lc-chip-list" aria-label="Selected concepts">
                        <mat-chip
                          *ngFor="let c of selectedLearningConcepts; let i = index"
                          class="lc-chip"
                          removable="true"
                          (removed)="selectedLearningConcepts.splice(i, 1)">
                          {{ c }}
                          <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                      </mat-chip-list>
                    </div>
                  </div>

                  <!-- ── Additional notes (Good Touch Bad Touch) — hidden ── -->
                  <!-- <div class="row">
                    <div class="col-12">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Good Touch Bad Touch — Notes</mat-label>
                        <textarea
                          matInput
                          [(ngModel)]="goodTouchBadTouch"
                          rows="6"
                          placeholder="Describe how the concept of Good Touch Bad Touch was taught...">
                        </textarea>
                        <mat-hint>Additional notes on concept teaching methodology</mat-hint>
                      </mat-form-field>
                    </div>
                  </div> -->

                </div>
              </div>

              <!-- Teaching Plan for 14-18 Years Component -->
              <div *ngIf="isComponentVisible('teaching-plan-14-18')" class="component-section">
                <div class="section-header">
                  <mat-icon>lightbulb</mat-icon>
                  <h5 class="teaching-plan-subheading">

                    Highlights
                  </h5>
                </div>

                <div class="section-content">
                  <!-- Highlights Heading -->
                  <div class="row mb-3">
                    <div class="col-12">

                    </div>
                  </div>

                  <!-- ── Highlights List (mat-expansion-panel) ── -->
                  <div class="row mb-4">
                    <div class="col-12">

                      <!-- Loading spinner -->
                      <mat-progress-bar *ngIf="isHighlightsLoading" mode="indeterminate" class="mb-2">
                      </mat-progress-bar>

                      <!-- Empty state -->
                      <p *ngIf="!isHighlightsLoading && highlightsDataSource.data.length === 0"
                         class="text-muted text-center py-2">
                        <mat-icon class="align-middle">star_border</mat-icon>
                        No highlighted sessions found for the selected period.
                      </p>

                      <!-- Highlights accordion -->
                      <div *ngIf="highlightsDataSource.data.length > 0">

                        <!-- Count badge -->
                        <div class="d-flex align-items-center mb-3">
                          <span class="hl-count-badge">
                            <mat-icon class="hl-count-icon">star</mat-icon>
                            {{ highlightsDataSource.data.length }} Highlight(s)
                          </span>
                        </div>

                        <div style="max-height:600px;overflow-y:auto;">
                        <mat-accordion multi="false">
                          <mat-expansion-panel
                            *ngFor="let row of pagedHighlights; let i = index"
                            class="hl-panel mb-1"
                            hideToggle="false">

                            <!-- ── Panel header ── -->
                            <mat-expansion-panel-header class="hl-panel-header">
                              <mat-panel-title class="hl-panel-title">

                                <!-- Sr no -->
                                <span class="hl-sr">{{ highlightsPageIndex * highlightsPageSize + i + 1 }}.</span>

                                <!-- Source badge -->
                                <span class="hl-source-badge"
                                      [style.background]="row._source === 'Follow-Up' ? '#7b1fa2' : '#1565c0'">
                                  {{ row._source || 'Individual' }}
                                </span>

                                <!-- Child name -->
                                <span class="hl-child-name">{{ row.childName || '-' }}</span>

                              </mat-panel-title>

                              <mat-panel-description class="hl-panel-desc">
                                <!-- Centre -->
                                <span class="hl-meta" *ngIf="row.centreName">
                                  <mat-icon class="hl-meta-icon">location_on</mat-icon>
                                  {{ row.centreName }}
                                </span>
                                <!-- Date -->
                                <span class="hl-meta">
                                  <mat-icon class="hl-meta-icon">event</mat-icon>
                                  {{ row.sessionDate?.toDate ? (row.sessionDate.toDate() | date:'dd-MMM-yyyy') : '-' }}
                                </span>
                                <!-- Session type -->
                                <span class="hl-meta" *ngIf="row.sessionType">
                                  <mat-icon class="hl-meta-icon">category</mat-icon>
                                  {{ row.sessionType }}
                                </span>
                                <!-- Teacher -->
                                <span class="hl-meta" *ngIf="row.submittedBy">
                                  <mat-icon class="hl-meta-icon">person</mat-icon>
                                  {{ row.submittedBy }}
                                </span>
                              </mat-panel-description>
                            </mat-expansion-panel-header>

                            <!-- ── Panel body (remark / highlight) ── -->

                            <!-- Individual session -->
                            <ng-container *ngIf="row._source !== 'Follow-Up'">

                              <!-- Session Details (primary highlight) -->
                              <p class="hl-remark-label">
                                <mat-icon>description</mat-icon>&nbsp;SESSION DETAILS
                              </p>
                              <ng-container *ngIf="row.sessionDetails; else noSessionDetails">
                                <div class="hl-remark-box mb-3">{{ row.sessionDetails }}</div>
                              </ng-container>
                              <ng-template #noSessionDetails>
                                <em class="hl-no-data d-block mb-3">No session details recorded.</em>
                              </ng-template>

                              <!-- Remark (secondary, shown only if present) -->
                              <ng-container *ngIf="row.remark">
                                <p class="hl-remark-label">
                                  <mat-icon>star</mat-icon>&nbsp;REMARK
                                </p>
                                <div class="hl-remark-box hl-remark-secondary">{{ row.remark }}</div>
                              </ng-container>

                            </ng-container>

                            <!-- Follow-Up session -->
                            <ng-container *ngIf="row._source === 'Follow-Up'">
                              <p class="hl-remark-label">
                                <mat-icon>star</mat-icon>&nbsp;REMARK &amp; HIGHLIGHTED QUESTION
                              </p>
                              <ng-container *ngIf="row.questions?.length > 0; else noFuRemark">
                                <div class="hl-fu-question">
                                  <p class="mb-1 fw-bold">
                                    {{ row.questions[row.questions.length - 1].question }}
                                  </p>
                                  <p class="mb-1">
                                    <span class="hl-ans-badge">
                                      {{ row.questions[row.questions.length - 1].ans }}
                                    </span>
                                  </p>
                                  <div class="hl-remark-box mt-1"
                                       *ngIf="row.questions[row.questions.length - 1].remark">
                                    {{ row.questions[row.questions.length - 1].remark }}
                                  </div>
                                </div>
                              </ng-container>
                              <ng-template #noFuRemark>
                                <em class="hl-no-data">No questions recorded for this follow-up.</em>
                              </ng-template>
                            </ng-container>

                          </mat-expansion-panel>
                        </mat-accordion>
                        </div><!-- /scrollable accordion wrapper -->

                        <mat-paginator
                          [length]="highlightsDataSource.data.length"
                          [pageSize]="highlightsPageSize"
                          [pageSizeOptions]="highlightsPageSizeOptions"
                          [pageIndex]="highlightsPageIndex"
                          (page)="onHighlightsPageChange($event)"
                          showFirstLastButtons>
                        </mat-paginator>

                      </div><!-- /highlights accordion wrapper -->
                    </div>
                  </div>

                  <!-- Parents Input — hidden -->
                  <!-- <div class="row mb-3">
                    <div class="col-12">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Parents</mat-label>
                        <textarea
                          matInput
                          [(ngModel)]="teachingPlanParents"
                          rows="6"
                          placeholder="Enter teaching plan details for parents of 14-18 years children...">
                        </textarea>
                        <mat-hint>Describe parent engagement activities and guidelines</mat-hint>
                      </mat-form-field>
                    </div>
                  </div> -->

                  <!-- Children Input — hidden -->
                  <!-- <div class="row">
                    <div class="col-12">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Children</mat-label>
                        <textarea
                          matInput
                          [(ngModel)]="teachingPlanChildren"
                          rows="6"
                          placeholder="Enter teaching plan details for 14-18 years children...">
                        </textarea>
                        <mat-hint>Describe curriculum, activities, and developmental goals for children</mat-hint>
                      </mat-form-field>
                    </div>
                  </div> -->
                </div>
              </div>

              <!-- Education Analytical Report Component -->
              <div *ngIf="isComponentVisible('education-analytical-report')" class="component-section">
                <div class="section-header">
                  <mat-icon>analytics</mat-icon>
                  <h5>Education Analytical Report</h5>
                </div>
                <div class="section-content">
                  <app-attendance-report
                    [hideFilters]="true"
                    [hideTable]="true"
                    [externalStartDate]="mStartDate"
                    [externalEndDate]="mEndDate"
                    [externalCentre]="selectedCentres"
                    [triggerSearch]="searchTrigger">
                  </app-attendance-report>
                </div>
              </div>

              <!-- Teacher Session Counts Component -->
              <div *ngIf="isComponentVisible('teacher-session-counts')" class="component-section">
                <div class="section-header">
                  <mat-icon>people</mat-icon>
                  <h5>Teacher Session Counts (Centre Wise)</h5>
                </div>
                <div class="section-content">
                  <app-education-count-report
                    [hideFilters]="true"
                    [externalStartDate]="mStartDate"
                    [externalEndDate]="mEndDate"
                    [externalCentre]="selectedCentres"
                    [triggerSearch]="searchTrigger">
                  </app-education-count-report>
                </div>
              </div>

              <!-- MIS Report Component -->
              <div *ngIf="isComponentVisible('mis-report')" class="component-section">
                <div class="section-header">
                  <mat-icon>description</mat-icon>
                  <h5>MIS Report</h5>
                </div>
                <div class="section-content">
                  <app-education-mis-reposrt
                    [hideFilters]="true"
                    [externalStartDate]="mStartDate"
                    [externalEndDate]="mEndDate"
                    [externalCentre]="selectedCentres"
                    [triggerSearch]="searchTrigger">
                  </app-education-mis-reposrt>
                </div>
              </div>

              <!-- Gallery Component -->
              <div *ngIf="isComponentVisible('gallery')" class="component-section">
                <div class="section-header">
                  <mat-icon>photo_library</mat-icon>
                  <h5>Gallery</h5>
                </div>
                <div class="section-content">

                  <!-- Empty State -->
                  <div *ngIf="galleryImages.length === 0" class="text-center py-4">
                    <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #999;">
                      photo_library
                    </mat-icon>
                    <p class="text-muted mt-2">No images selected</p>
                    <button mat-raised-button color="accent" (click)="openPhotoGallery()">
                      <mat-icon>add_photo_alternate</mat-icon>
                      Select Images from Gallery
                    </button>
                  </div>

                  <!-- Gallery with Images -->
                  <div *ngIf="galleryImages.length > 0">
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <div>
                        <span class="badge badge-primary" style="font-size: 14px; padding: 8px 16px;">
                          {{ galleryImages.length }} Image(s) Selected
                        </span>
                      </div>
                      <div>
                        <button mat-raised-button color="accent" (click)="openPhotoGallery()" class="mr-2">
                          <mat-icon>add</mat-icon>
                          Add More
                        </button>
                        <button mat-raised-button color="warn" (click)="clearGallery()">
                          <mat-icon>clear_all</mat-icon>
                          Clear All
                        </button>
                      </div>
                    </div>

                    <!-- Gallery Grid -->
                    <div class="gallery-grid">
                      <div *ngFor="let image of galleryImages; let i = index" class="gallery-item">
                        <div class="image-container">
                          <img [src]="image.url"
                               [alt]="image.fileName"
                               (click)="openImageInNewTab(image.url)"
                               class="gallery-image">
                          <div class="image-overlay">
                            <button mat-mini-fab color="warn"
                                    (click)="removeImageFromGallery(i)"
                                    class="remove-btn">
                              <mat-icon>delete</mat-icon>
                            </button>
                          </div>
                        </div>
                        <div class="image-info">
                          <div class="image-filename" [title]="image.fileName">
                            {{ image.fileName }}
                          </div>
                          <div class="image-meta" *ngIf="image.centreName">
                            <mat-icon class="meta-icon">location_on</mat-icon>
                            {{ image.centreName }}
                          </div>
                          <div class="image-meta" *ngIf="image.description">
                            <mat-icon class="meta-icon">description</mat-icon>
                            {{ image.description }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <!-- Remarks Component -->
              <div *ngIf="isComponentVisible('remarks')" class="component-section">
                <div class="section-header">
                  <mat-icon>comment</mat-icon>
                  <h5>Remarks</h5>
                </div>
                <div class="section-content">
                  <div class="row">
                    <div class="col-12">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Remarks</mat-label>
                        <textarea
                          matInput
                          [(ngModel)]="remarks"
                          rows="10"
                          placeholder="Enter any additional remarks, observations, or notes...">
                        </textarea>
                        <mat-hint>Add any final notes, observations, or important remarks about the education presentation</mat-hint>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>



